import { ReactComponent as Icon } from "../images/round-land.svg";

const RoundLandIcon = ({ size = "120", color = "#5EC394" }) => {
  return (
    <>
      <Icon width={size} height={size} fill={color} />
    </>
  );
};
export default RoundLandIcon;